<template>
    <Popup
            v-model="popupShow"
            position="bottom"
            radius="5px"
            class="select-safety-template-popup"
            @close="onCancel"
    >
        <div class="popup-bar">
            <div class="cancel" @click="onCancel">取消</div>
            <div class="title"> 选择模板</div>
            <div class="ok" @click="onOk">确定</div>
        </div>
        <div class="content">
            <List
                    style="height: 100%;margin-top:-5px;padding: 5px 12px"
                    :offset="50"
                    :immediate-check="true"
            >

                <CheckboxGroup v-model="selected">
                    <Checkbox v-for="(item) in templates"
                              :key="item.id" :name="item.id" shape="square">
                        {{item.name}}
                    </Checkbox>
                </CheckboxGroup>
            </List>
        </div>
    </Popup>
</template>

<script>
    import {Checkbox, CheckboxGroup, List, Popup, Sticky} from "vant"
    import {downloadImg} from "@/config"

    export default {
        components: {
            Popup, List, Sticky, CheckboxGroup, Checkbox
        },
        props: {
            show: {type: Boolean, default: false},
            templates: {type: Array, required: true},
            defaultSelected: {type: Array, default: () => []},
        },
        data() {
            return {
                selected: []
            }
        },
        mounted() {
            this.changeSelected(this.defaultSelected)
        },
        computed: {
            popupShow: {
                get() {
                    return this.show
                },
                set() {
                    this.onCancel()
                }
            },
            // title() {
            //     return (this.selected||{}).productName || this.defaultTitle
            // },
        },
        methods: {
            onCancel() {
                this.$emit('cancel')
            },
            onOk() {
                // 格式转换
                const templates = this.templates.filter(item => this.selected.includes(item.id))
                this.$emit('ok', templates)
            },
            getImgUrl(url) {
                return downloadImg + url
            },
            changeSelected(selected) {
                this.selected = selected.map(item => item.id)
                console.info('当前选中', this.selected, selected)
            }
        },
        watch: {
            defaultSelected(value) {
                this.changeSelected(value)
            }
        }
    };
</script>
<style lang="less" scoped>
    .select-safety-template-popup {
        height: calc(100% - 140px);
        & > .content {
            display: flex;
            flex-direction: column;
            height: calc(100% - 50px);
            overflow-y: auto;
        }
        .van-checkbox {
            padding: 8px;
            margin: 3px;
            background: #f3f3f3
        }
    }

</style>
